<ul class="error-messages" *ngIf="errorList">
  <li *ngFor="let error of errorList">
    {{ error }}
  </li>
</ul>
